import Axios from './base';

export const CreateAssetBuilder = (entity) => Axios().post('Assets/CreateAsset', entity);
 
export const getMyAssets = (id) => Axios().get('Assets/GetMyAsset/' + id);
export const getMyAssetsPaginated = (id, params) => Axios().get('Assets/GetMyAssetPaginated/' + id, { params });

export const UpdateAssetBuilder = (id, entity) => Axios().put('Assets/UpdateAsset/' + id, entity);

 
export const getAssetById = (id) => Axios(null, "Invalid Id").get('Assets/GetAssetById/' + id);

 

export const getAllMyAssets = () => Axios().get('Assets/GetAllMyAssets');
 

export const getAssetBuilder = () => Axios().get('Assets/GetAssets');

export const GetSimulateAsset = (id) => Axios().get('Assets/GetSimulateAsset/' + id);   

export const UpdateSimulateAsset = (id, entity) => Axios().post(`Assets/UpdateSimulateAsset/${id}`, entity);
 

export const simulateAsset = (entity) => Axios().post('Assets/SimulateAsset', entity);

export const GetSimulateAssetfields = (entity) => Axios().get('Assets/GetSimulateAssetfields');


